var MemberList = require('memberlist');


var MemberAdminList = MemberList.extend({
    modeCategory: 'ADMIN'
});


module.exports = MemberAdminList;



//////////////////
// WEBPACK FOOTER
// ./app/src/collection/memberadminlist.js
// module id = WeW2
// module chunks = 1